export default {
    modal_move: {
        status: 'Move Status - {{title}}',
        task: 'Move Task - {{title}}',
        all_tasks: 'Move All Tasks with Status - {{title}}'
    },
    error: {
        move_tasks: 'Could not move the following tasks',
        archive_tasks: 'Could not archive the following tasks',
    },
    alert: {
        archive_all_tasks_title: 'Do you want to archive all tasks with status {{status}}?',
        archive_all_tasks_text: 'After archiving the tasks, it will no longer be possible to update them.',
    },
}
